import React, { useEffect, useState, useContext } from "react";
import { API_URL, createAxiosInstance } from "../../../../api";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import config from "config";
const BillingHistory = () => {
  const [billingHistory, setBillingHistory] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();
  const { email } = useSelector((state) => state.profile.user);
  const userId = useSelector((state) => state.profile.user.user);
  const [isLive, setIsLive] = useState("");
  const [hasFetchedStatus, setHasFetchedStatus] = useState(false);

  useEffect(() => {
    const fetchStatusAndHistory = async () => {
      if (!userId) return;
      try {
        const axiosInstance = createAxiosInstance();
        // First check subscription status
        const statusRes = await axiosInstance.get(`${API_URL}/api/billings/status/${userId}`);
        const { status } = statusRes.data || {};
        const normalized = status || "inactive";
        setIsLive(normalized);
        setHasFetchedStatus(true);

        const hasPaid = ["active", "paused", "past_due", "canceled"].includes(normalized);
        if (!hasPaid) {
          // No subscription yet; avoid fetching history and redirect out
          setBillingHistory([]);
          navigate("/dashboard");
          return;
        }

        // Fetch history only when there is an active/paid subscription
        const historyRes = await axiosInstance.get(`${API_URL}/api/billings/history/${userId}`);
        setBillingHistory(historyRes.data.history || []);
      } catch (err) {
        console.error("Error fetching billing status/history:", err);
      }
    };

    fetchStatusAndHistory();
  }, [email, userId, navigate]);

  return (
    <div className="billing-container">
      <div className="billing-menu">
        <div className="returnToDash">
          {" "}
          <Link to="/dashboard">
            <svg
              id="Layer_1"
              data-name="Layer 1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 122.88 108.06"
            >
              <title>back-arrow</title>
              <path d="M63.94,24.28a14.28,14.28,0,0,0-20.36-20L4.1,44.42a14.27,14.27,0,0,0,0,20l38.69,39.35a14.27,14.27,0,0,0,20.35-20L48.06,68.41l60.66-.29a14.27,14.27,0,1,0-.23-28.54l-59.85.28,15.3-15.58Z" />
            </svg>
            Back To Dashboard
          </Link>
        </div>
        {["active", "paused", "past_due", "canceled"].includes(isLive) && (
          <Link
            className={
              "tab" +
              (location.pathname === "/billing"
                ? " active " + config["class-name"]
                : "")
            }
            to="/billing"
          >
            My Plan
          </Link>
        )}
        {["active", "paused", "past_due", "canceled"].includes(isLive) && (
          <Link
            className={
              "tab" +
              (location.pathname === "/billing/history"
                ? " active " + config["class-name"]
                : "")
            }
            to="/billing/history"
          >
            History
          </Link>
        )}
        {["active", "paused", "past_due", "canceled"].includes(isLive) && (
          <Link
            className={
              "tab" +
              (location.pathname === "/billing/saved-cards"
                ? " active " + config["class-name"]
                : "")
            }
            to="/billing/saved-cards"
          >
            Saved Cards
          </Link>
        )}
        {["active", "paused", "past_due", "canceled"].includes(isLive) && (
          <Link
            className={`tab${
              location.pathname === "/billing/change-plan"
                ? " active " + config["class-name"]
                : ""
            }`}
            to="/billing/change-plan"
          >
            Change Plan
          </Link>
        )}
      </div>

      <div className="billing-content">
        <div className="billing-history-section">
          <h1 className="page-title">Billing History</h1>
          <table>
            <thead>
              <tr>
                <th>Date</th>
                <th>Amount</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {billingHistory.map((entry, index) => (
                <tr key={index}>
                  <td>{new Date(entry.periodStart).toLocaleDateString()}</td>
                  <td>£{entry.amountPaid}</td>
                  <td>{entry.status}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default BillingHistory;
